import { Env } from "@stencil/core";
import { WCEnvironment } from "../types";

export const API_PATHS = {
  GET_AUTH_CUSTOMER_FINTECH: 'api/v1/public/auth/customer-token',
  GET_AUTH_INTEGRATOR_FINTECH: 'api/v1/public/auth/integrator-token',
  HIRE_FINTECH: 'api/v1/admin/credenciamento/pre-contratacao/efetivar',
  GET_DDA_COMPANIES_STATUSES: 'api/v1/credenciamento/dda/empresas/status',
};

export const BASE_URL_ENV_LOOKUP: { [key in WCEnvironment]?: string } = {
  local: Env.FIN_BANK_WEBCOMPONENTS_API_URL,
  dev: 'https://fintechapi-dev.sandbox-oke.sankhya.com.br/',
  hml: 'https://fintechapi-hml.sandbox-oke.sankhya.com.br/',
  prd: 'https://fintechapi.sankhya.com.br/',
};

export enum EFintechService {
  BANK_SLIP = 'BOLETO_RAPIDO',
  PIX = 'PIX',
  PAYMENTS = 'PAGAMENTO',
  DDA = 'DDA',
  SCORE = 'SCORE',
}
